import { useEffect, useState } from "react";

/** Slim bottom strip shown only while offline. Reads still work from the SW
 *  cache; this just signals that writes need a connection. */
export function OfflineIndicator() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: "calc(64px + env(safe-area-inset-bottom))",
        zIndex: 54,
        textAlign: "center",
        padding: "6px 12px",
        background: "var(--status-cancelled-bg)",
        color: "var(--status-cancelled)",
        fontSize: 12.5,
        fontWeight: 500,
      }}
    >
      You're offline — showing saved data. Reconnect to make changes.
    </div>
  );
}
